export const LS = {
    get(key, defaultValue) {
        var _a;
        if (__SERVER__)
            return defaultValue;
        const rs = localStorage.getItem(key);
        try {
            return (_a = JSON.parse(rs)) !== null && _a !== void 0 ? _a : defaultValue;
        }
        catch (error) {
            return defaultValue;
        }
    },
    set(key, value) {
        if (__SERVER__)
            return;
        return localStorage.setItem(key, JSON.stringify(value));
    },
};
